import type * as Types from '@xingternal/pages-graphql-types';

import type { EntityPageFeedCollectionFragment } from './EntityPageFeedCollectionFragment.gql-types.js';
import * as Operations from './FeedQuery.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityPageFeedQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  until?: Types.InputMaybe<Types.Scalars['String']['input']>;
  since?: Types.InputMaybe<Types.Scalars['String']['input']>;
  filter?: Types.InputMaybe<Types.PostingPublicationState>;
}>;


export type EntityPageFeedQuery = (
  { __typename?: 'Query' }
  & { entityPageContentFeeds?: Types.Maybe<(
    { __typename?: 'EntityPageContentFeedCollection' }
    & { metadata?: Types.Maybe<(
      { __typename?: 'EntityPageContentFeedCollectionMetadata' }
      & Pick<Types.EntityPageContentFeedCollectionMetadata, 'draftTotal' | 'scheduledTotal' | 'hiddenTotal'>
    )>, collection?: Types.Maybe<Array<(
      { __typename?: 'EntityPageContentFeedUpdate' }
      & EntityPageFeedCollectionFragment
    )>> }
  )> }
);



/**
 * __useEntityPageFeedQuery__
 *
 * To run a query within a React component, call `useEntityPageFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPageFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPageFeedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      until: // value for 'until'
 *      since: // value for 'since'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEntityPageFeedQuery(baseOptions: Apollo.QueryHookOptions<EntityPageFeedQuery, EntityPageFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityPageFeedQuery, EntityPageFeedQueryVariables>(Operations.entityPageFeed, options);
      }
export function useEntityPageFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityPageFeedQuery, EntityPageFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityPageFeedQuery, EntityPageFeedQueryVariables>(Operations.entityPageFeed, options);
        }
export type EntityPageFeedQueryHookResult = ReturnType<typeof useEntityPageFeedQuery>;
export type EntityPageFeedLazyQueryHookResult = ReturnType<typeof useEntityPageFeedLazyQuery>;
export type EntityPageFeedQueryResult = Apollo.QueryResult<EntityPageFeedQuery, EntityPageFeedQueryVariables>;